@import "tailwindcss";
@import "tw-animate-css";
/* Vendored from the shadcn package (not a dependency of this project). */
@import "./shadcn-tailwind.css";
@import "@fontsource-variable/geist";

@custom-variant dark (&:is(.dark *));

@theme inline {
  --font-heading: var(--font-sans);
  --font-sans: "Geist Variable", sans-serif;
  --color-sidebar-ring: var(--sidebar-ring);
  --color-sidebar-border: var(--sidebar-border);
  --color-sidebar-accent-foreground: var(--sidebar-accent-foreground);
  --color-sidebar-accent: var(--sidebar-accent);
  --color-sidebar-primary-foreground: var(--sidebar-primary-foreground);
  --color-sidebar-primary: var(--sidebar-primary);
  --color-sidebar-foreground: var(--sidebar-foreground);
  --color-sidebar: var(--sidebar);
  --color-chart-5: var(--chart-5);
  --color-chart-4: var(--chart-4);
  --color-chart-3: var(--chart-3);
  --color-chart-2: var(--chart-2);
  --color-chart-1: var(--chart-1);
  --color-ring: var(--ring);
  --color-input: var(--input);
  --color-border: var(--border);
  --color-destructive: var(--destructive);
  --color-accent-foreground: var(--accent-foreground);
  --color-accent: var(--accent);
  --color-muted-foreground: var(--muted-foreground);
  --color-muted: var(--muted);
  --color-secondary-foreground: var(--secondary-foreground);
  --color-secondary: var(--secondary);
  --color-primary-foreground: var(--primary-foreground);
  --color-primary: var(--primary);
  --color-popover-foreground: var(--popover-foreground);
  --color-popover: var(--popover);
  --color-card-foreground: var(--card-foreground);
  --color-card: var(--card);
  --color-foreground: var(--foreground);
  --color-background: var(--background);
  --radius-sm: calc(var(--radius) * 0.6);
  --radius-md: calc(var(--radius) * 0.8);
  --radius-lg: var(--radius);
  --radius-xl: calc(var(--radius) * 1.4);
  --radius-2xl: calc(var(--radius) * 1.8);
  --radius-3xl: calc(var(--radius) * 2.2);
  --radius-4xl: calc(var(--radius) * 2.6);
}

:root {
  --background: oklch(1 0 0);
  --foreground: oklch(0.145 0 0);
  --card: oklch(1 0 0);
  --card-foreground: oklch(0.145 0 0);
  --popover: oklch(1 0 0);
  --popover-foreground: oklch(0.145 0 0);
  --primary: oklch(0.205 0 0);
  --primary-foreground: oklch(0.985 0 0);
  --secondary: oklch(0.97 0 0);
  --secondary-foreground: oklch(0.205 0 0);
  --muted: oklch(0.97 0 0);
  --muted-foreground: oklch(0.556 0 0);
  --accent: oklch(0.97 0 0);
  --accent-foreground: oklch(0.205 0 0);
  --destructive: oklch(0.577 0.245 27.325);
  --border: oklch(0.922 0 0);
  --input: oklch(0.922 0 0);
  --ring: oklch(0.708 0 0);
  --chart-1: oklch(0.87 0 0);
  --chart-2: oklch(0.556 0 0);
  --chart-3: oklch(0.439 0 0);
  --chart-4: oklch(0.371 0 0);
  --chart-5: oklch(0.269 0 0);
  --radius: 0.625rem;
  --sidebar: oklch(0.985 0 0);
  --sidebar-foreground: oklch(0.145 0 0);
  --sidebar-primary: oklch(0.205 0 0);
  --sidebar-primary-foreground: oklch(0.985 0 0);
  --sidebar-accent: oklch(0.97 0 0);
  --sidebar-accent-foreground: oklch(0.205 0 0);
  --sidebar-border: oklch(0.922 0 0);
  --sidebar-ring: oklch(0.708 0 0);
}

.dark {
  --background: oklch(0.145 0 0);
  --foreground: oklch(0.985 0 0);
  --card: oklch(0.205 0 0);
  --card-foreground: oklch(0.985 0 0);
  --popover: oklch(0.205 0 0);
  --popover-foreground: oklch(0.985 0 0);
  --primary: oklch(0.922 0 0);
  --primary-foreground: oklch(0.205 0 0);
  --secondary: oklch(0.269 0 0);
  --secondary-foreground: oklch(0.985 0 0);
  --muted: oklch(0.269 0 0);
  --muted-foreground: oklch(0.708 0 0);
  --accent: oklch(0.269 0 0);
  --accent-foreground: oklch(0.985 0 0);
  --destructive: oklch(0.704 0.191 22.216);
  --border: oklch(1 0 0 / 10%);
  --input: oklch(1 0 0 / 15%);
  --ring: oklch(0.556 0 0);
  --chart-1: oklch(0.87 0 0);
  --chart-2: oklch(0.556 0 0);
  --chart-3: oklch(0.439 0 0);
  --chart-4: oklch(0.371 0 0);
  --chart-5: oklch(0.269 0 0);
  --sidebar: oklch(0.205 0 0);
  --sidebar-foreground: oklch(0.985 0 0);
  --sidebar-primary: oklch(0.488 0.243 264.376);
  --sidebar-primary-foreground: oklch(0.985 0 0);
  --sidebar-accent: oklch(0.269 0 0);
  --sidebar-accent-foreground: oklch(0.985 0 0);
  --sidebar-border: oklch(1 0 0 / 10%);
  --sidebar-ring: oklch(0.556 0 0);
}

@layer base {
  * {
    @apply border-border outline-ring/50;
  }
  body {
    @apply bg-background text-foreground;
  }
  html {
    @apply font-sans;
  }
}
/* ===================== blamy-notes GitBook clone ===================== */

.gb-app {
  display: flex;
  height: 100vh;
  overflow: hidden;
}

/* --- Sidebar --- */
.gb-sidebar {
  width: 260px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  border-right: 1px solid var(--border);
  background: var(--sidebar, var(--muted));
  position: relative;
}
.gb-sidebar-head {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 14px 16px;
  border-bottom: 1px solid var(--border);
}
.gb-sidebar-pages {
  flex: 1;
  overflow-y: auto;
  padding: 8px;
}
.gb-page-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  color: var(--muted-foreground);
}
.gb-page-item:hover {
  background: var(--accent);
  color: var(--accent-foreground);
}
.gb-page-item-active {
  background: var(--accent);
  color: var(--accent-foreground);
  font-weight: 500;
}
.gb-page-delete {
  margin-left: auto;
  opacity: 0;
  color: var(--muted-foreground);
}
.gb-page-item:hover .gb-page-delete {
  opacity: 1;
}
.gb-page-add {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 6px 10px;
  border-radius: 6px;
  font-size: 14px;
  color: var(--muted-foreground);
  margin-top: 4px;
}
.gb-page-add:hover {
  background: var(--accent);
}
.gb-sidebar-foot {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 2px;
  padding: 8px;
  border-top: 1px solid var(--border);
}
.gb-github-panel {
  position: absolute;
  bottom: 90px;
  left: 8px;
  right: 8px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 12px;
  border: 1px solid var(--border);
  border-radius: 10px;
  background: var(--popover);
  box-shadow: 0 8px 24px rgb(0 0 0 / 0.12);
  z-index: 30;
}
.gb-repo-select {
  width: 100%;
  padding: 6px 8px;
  border: 1px solid var(--border);
  border-radius: 6px;
  background: var(--background);
  font-size: 13px;
}

/* --- Main / header --- */
.gb-main {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.gb-header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 10px 20px;
  border-bottom: 1px solid var(--border);
}
.gb-title-input {
  max-width: 280px;
  border: none;
  box-shadow: none;
  font-weight: 600;
  font-size: 15px;
  background: transparent;
}
.gb-view-tabs {
  display: flex;
  gap: 2px;
  margin-left: auto;
  background: var(--muted);
  border-radius: 8px;
  padding: 3px;
}
.gb-view-tab {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 5px 12px;
  border-radius: 6px;
  font-size: 13px;
  color: var(--muted-foreground);
}
.gb-view-tab-active {
  background: var(--background);
  color: var(--foreground);
  box-shadow: 0 1px 2px rgb(0 0 0 / 0.08);
}
.gb-save-state {
  font-size: 12px;
  color: var(--muted-foreground);
  min-width: 52px;
  text-align: right;
}
.gb-content {
  flex: 1;
  overflow-y: auto;
}
.gb-empty {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
  color: var(--muted-foreground);
}
.gb-raw {
  width: 100%;
  height: 100%;
  padding: 32px 40px;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 13px;
  line-height: 1.6;
  background: var(--background);
  resize: none;
  outline: none;
}

/* --- Editor chrome --- */
.gb-editor {
  max-width: 860px;
  margin: 0 auto;
  padding: 16px 24px 120px;
}
.gb-toolbar {
  position: sticky;
  top: 0;
  z-index: 20;
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
  align-items: center;
  padding: 6px;
  margin-bottom: 16px;
  border: 1px solid var(--border);
  border-radius: 10px;
  background: color-mix(in oklab, var(--background) 92%, transparent);
  backdrop-filter: blur(6px);
}
.gb-tool {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 6px;
  color: var(--muted-foreground);
}
.gb-tool:hover {
  background: var(--accent);
  color: var(--accent-foreground);
}
.gb-tool-active {
  background: var(--accent);
  color: var(--accent-foreground);
}
.gb-toolbar-sep {
  width: 1px;
  height: 18px;
  background: var(--border);
  margin: 0 6px;
}

.gb-editor-content .tiptap {
  outline: none;
  min-height: 50vh;
}
.gb-editor-content .tiptap > * + * {
  margin-top: 0.7em;
}
.gb-editor-content .tiptap h1 {
  font-size: 2em;
  font-weight: 700;
  margin-top: 1em;
}
.gb-editor-content .tiptap h2 {
  font-size: 1.5em;
  font-weight: 650;
  margin-top: 1em;
}
.gb-editor-content .tiptap h3 {
  font-size: 1.2em;
  font-weight: 600;
  margin-top: 0.9em;
}
.gb-editor-content .tiptap ul:not([data-type="taskList"]) {
  list-style: disc;
  padding-left: 1.4em;
}
.gb-editor-content .tiptap ol {
  list-style: decimal;
  padding-left: 1.4em;
}
.gb-editor-content .tiptap ul[data-type="taskList"] {
  list-style: none;
  padding-left: 0.2em;
}
.gb-editor-content .tiptap ul[data-type="taskList"] li {
  display: flex;
  gap: 8px;
}
.gb-editor-content .tiptap ul[data-type="taskList"] li > label {
  flex-shrink: 0;
  margin-top: 3px;
}
.gb-editor-content .tiptap ul[data-type="taskList"] li > div {
  flex: 1;
}
.gb-editor-content .tiptap blockquote {
  border-left: 3px solid var(--border);
  padding-left: 1em;
  color: var(--muted-foreground);
}
.gb-editor-content .tiptap hr {
  border: none;
  border-top: 1px solid var(--border);
  margin: 1.4em 0;
}
.gb-editor-content .tiptap a {
  color: oklch(0.55 0.18 255);
  text-decoration: underline;
}
.gb-editor-content .tiptap code {
  background: var(--muted);
  border-radius: 4px;
  padding: 0.15em 0.35em;
  font-size: 0.875em;
  font-family: ui-monospace, Menlo, monospace;
}
.gb-editor-content .tiptap p.is-editor-empty:first-child::before {
  content: attr(data-placeholder);
  float: left;
  color: var(--muted-foreground);
  pointer-events: none;
  height: 0;
}
.gb-editor-content .tiptap table {
  border-collapse: collapse;
  width: 100%;
}
.gb-editor-content .tiptap th,
.gb-editor-content .tiptap td {
  border: 1px solid var(--border);
  padding: 6px 10px;
  text-align: left;
}
.gb-editor-content .tiptap th {
  background: var(--muted);
  font-weight: 600;
}

/* --- Shared inline inputs in node views --- */
.gb-inline-input {
  background: transparent;
  border: none;
  outline: none;
  font: inherit;
  color: inherit;
  width: auto;
  min-width: 60px;
}
.gb-inline-input::placeholder {
  color: var(--muted-foreground);
}
.gb-icon-btn {
  display: inline-flex;
  align-items: center;
  color: var(--muted-foreground);
  border-radius: 4px;
  padding: 2px;
}
.gb-icon-btn:hover {
  background: var(--accent);
}

/* --- Hint --- */
.gb-hint {
  display: flex;
  gap: 10px;
  padding: 12px 14px;
  border-radius: 10px;
  border: 1px solid;
  margin: 0.7em 0;
}
.gb-hint-gutter {
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: center;
  padding-top: 2px;
}
.gb-hint-style {
  font-size: 10px;
  background: transparent;
  border: 1px solid var(--border);
  border-radius: 4px;
}
.gb-hint-body {
  flex: 1;
  min-width: 0;
}
.gb-hint-info {
  border-color: oklch(0.7 0.12 240 / 0.4);
  background: oklch(0.7 0.12 240 / 0.08);
}
.gb-hint-info .gb-hint-gutter {
  color: oklch(0.55 0.15 240);
}
.gb-hint-success {
  border-color: oklch(0.7 0.15 150 / 0.4);
  background: oklch(0.7 0.15 150 / 0.08);
}
.gb-hint-success .gb-hint-gutter {
  color: oklch(0.5 0.15 150);
}
.gb-hint-warning {
  border-color: oklch(0.75 0.15 80 / 0.5);
  background: oklch(0.75 0.15 80 / 0.1);
}
.gb-hint-warning .gb-hint-gutter {
  color: oklch(0.6 0.14 70);
}
.gb-hint-danger {
  border-color: oklch(0.6 0.2 25 / 0.4);
  background: oklch(0.6 0.2 25 / 0.08);
}
.gb-hint-danger .gb-hint-gutter {
  color: oklch(0.55 0.2 25);
}

/* --- Tabs --- */
.gb-tabs {
  border: 1px solid var(--border);
  border-radius: 10px;
  margin: 0.7em 0;
  overflow: hidden;
}
.gb-tabs-header {
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 6px 8px 0;
  background: var(--muted);
  border-bottom: 1px solid var(--border);
}
.gb-tabs-tab {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 12px;
  border-radius: 8px 8px 0 0;
  font-size: 13px;
  cursor: pointer;
  color: var(--muted-foreground);
}
.gb-tabs-tab-active {
  background: var(--background);
  color: var(--foreground);
  font-weight: 500;
  box-shadow:
    0 -1px 0 var(--border),
    1px 0 0 var(--border),
    -1px 0 0 var(--border);
}
.gb-tabs-title-input {
  background: transparent;
  border: none;
  outline: none;
  font: inherit;
  color: inherit;
}
.gb-tabs-content {
  padding: 12px 14px;
}
.gb-tabs-content > .gb-tab {
  display: none;
}
.gb-tabs-content[data-active="0"] > .gb-tab:nth-child(1),
.gb-tabs-content[data-active="1"] > .gb-tab:nth-child(2),
.gb-tabs-content[data-active="2"] > .gb-tab:nth-child(3),
.gb-tabs-content[data-active="3"] > .gb-tab:nth-child(4),
.gb-tabs-content[data-active="4"] > .gb-tab:nth-child(5),
.gb-tabs-content[data-active="5"] > .gb-tab:nth-child(6),
.gb-tabs-content[data-active="6"] > .gb-tab:nth-child(7),
.gb-tabs-content[data-active="7"] > .gb-tab:nth-child(8) {
  display: block;
}

/* --- Expandable --- */
.gb-expandable {
  border: 1px solid var(--border);
  border-radius: 10px;
  margin: 0.7em 0;
}
.gb-expandable-summary {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  font-weight: 500;
  background: var(--muted);
  border-radius: 10px 10px 0 0;
  border-bottom: 1px solid var(--border);
}
.gb-expandable-summary .gb-inline-input {
  flex: 1;
}
.gb-expandable-body {
  padding: 12px 14px;
}

/* --- Stepper --- */
.gb-stepper {
  margin: 0.7em 0;
}
.gb-step {
  display: flex;
  gap: 14px;
}
.gb-step-rail {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.gb-step-badge {
  width: 28px;
  height: 28px;
  border-radius: 999px;
  background: var(--muted);
  border: 1px solid var(--border);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 600;
  flex-shrink: 0;
}
.gb-step-line {
  width: 1px;
  flex: 1;
  background: var(--border);
  margin: 4px 0;
}
.gb-step-main {
  flex: 1;
  min-width: 0;
  padding-bottom: 18px;
}
.gb-step-title {
  font-weight: 600;
  font-size: 15px;
  width: 100%;
  margin: 4px 0 2px;
}

/* --- Embed / content-ref --- */
.gb-embed {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: 0.7em 0;
}
.gb-embed-frame {
  width: 100%;
  aspect-ratio: 16 / 9;
  border: 1px solid var(--border);
  border-radius: 10px;
}
.gb-embed-link {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 14px;
  border: 1px solid var(--border);
  border-radius: 10px;
  color: oklch(0.55 0.18 255);
}
.gb-embed-input {
  font-size: 12px;
  color: var(--muted-foreground);
  width: 100%;
}
.gb-content-ref {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  border: 1px solid var(--border);
  border-radius: 10px;
  margin: 0.7em 0;
  font-weight: 500;
}
.gb-content-ref-url {
  font-size: 12px;
  color: var(--muted-foreground);
  font-weight: 400;
  flex: 1;
}

/* --- Columns --- */
.gb-columns {
  display: flex;
  gap: 16px;
  margin: 0.7em 0;
}
.gb-columns > .gb-column {
  flex: 1;
  min-width: 0;
  border: 1px dashed var(--border);
  border-radius: 10px;
  padding: 10px 12px;
}

/* --- Figure --- */
.gb-figure {
  margin: 0.7em 0;
}
.gb-figure-img {
  border-radius: 10px;
  max-width: 100%;
}
.gb-figure-placeholder {
  padding: 28px;
  border: 1px dashed var(--border);
  border-radius: 10px;
  text-align: center;
  color: var(--muted-foreground);
}
.gb-figure-fields {
  display: flex;
  gap: 12px;
  margin-top: 6px;
}
.gb-figure-fields .gb-inline-input {
  font-size: 12px;
  color: var(--muted-foreground);
  flex: 1;
}
.gb-figure-caption {
  text-align: center;
  font-size: 13px;
  color: var(--muted-foreground);
  margin-top: 6px;
}

/* --- Math --- */
.gb-math {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  border: 1px solid var(--border);
  border-radius: 10px;
  padding: 12px 14px;
  margin: 0.7em 0;
  background: var(--muted);
}
.gb-math-label {
  font-size: 10px;
  font-weight: 700;
  color: var(--muted-foreground);
  border: 1px solid var(--border);
  border-radius: 4px;
  padding: 1px 5px;
  margin-top: 3px;
}
.gb-math-input {
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  resize: vertical;
  font-family: ui-monospace, Menlo, monospace;
  font-size: 13px;
}
.gb-math-formula {
  flex: 1;
  font-family: ui-monospace, Menlo, monospace;
  font-size: 13px;
  white-space: pre-wrap;
}

/* --- Code block --- */
.gb-code {
  border: 1px solid var(--border);
  border-radius: 10px;
  margin: 0.7em 0;
  overflow: hidden;
}
.gb-code-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 12px;
  background: var(--muted);
  border-bottom: 1px solid var(--border);
  font-size: 12px;
}
.gb-code-title {
  font-weight: 500;
}
.gb-code-lang {
  margin-left: auto;
  color: var(--muted-foreground);
  width: 70px;
  text-align: right;
}
.gb-code-linenos {
  display: flex;
  gap: 4px;
  align-items: center;
  color: var(--muted-foreground);
  font-size: 11px;
}
.gb-code pre {
  padding: 12px 14px;
  overflow-x: auto;
  font-family: ui-monospace, Menlo, monospace;
  font-size: 13px;
  line-height: 1.55;
}
.gb-code pre code {
  background: none;
  padding: 0;
}

/* --- Docs (published) view --- */
.docs-article {
  max-width: 760px;
  margin: 0 auto;
  padding: 48px 32px 120px;
  line-height: 1.65;
  font-size: 15.5px;
}
.docs-article > div > * + * {
  margin-top: 0.85em;
}
.docs-article h1 {
  font-size: 2.2em;
  font-weight: 700;
  margin-top: 0.6em;
  letter-spacing: -0.02em;
}
.docs-article h2 {
  font-size: 1.5em;
  font-weight: 650;
  margin-top: 1.4em;
  padding-bottom: 0.2em;
  border-bottom: 1px solid var(--border);
}
.docs-article h3 {
  font-size: 1.2em;
  font-weight: 600;
  margin-top: 1.1em;
}
.docs-article a {
  color: oklch(0.55 0.18 255);
  text-decoration: underline;
}
.docs-article code {
  background: var(--muted);
  border-radius: 4px;
  padding: 0.15em 0.35em;
  font-size: 0.875em;
  font-family: ui-monospace, Menlo, monospace;
}
.docs-article ul {
  list-style: disc;
  padding-left: 1.5em;
}
.docs-article ol {
  list-style: decimal;
  padding-left: 1.5em;
}
.docs-article .docs-tasklist {
  list-style: none;
  padding-left: 0.2em;
}
.docs-article .docs-tasklist li {
  display: flex;
  gap: 8px;
  align-items: baseline;
}
.docs-article blockquote {
  border-left: 3px solid var(--border);
  padding-left: 1em;
  color: var(--muted-foreground);
}
.docs-article hr {
  border: none;
  border-top: 1px solid var(--border);
  margin: 2em 0;
}
.docs-article figure img {
  border-radius: 12px;
  max-width: 100%;
}
.docs-article figcaption {
  text-align: center;
  font-size: 13px;
  color: var(--muted-foreground);
  margin-top: 8px;
}

.docs-hint {
  display: flex;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 12px;
  border: 1px solid;
}
.docs-hint-icon {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  margin-top: 3px;
}
.docs-hint > div {
  flex: 1;
  min-width: 0;
}
.docs-hint-info {
  border-color: oklch(0.7 0.12 240 / 0.4);
  background: oklch(0.7 0.12 240 / 0.08);
}
.docs-hint-info .docs-hint-icon {
  color: oklch(0.55 0.15 240);
}
.docs-hint-success {
  border-color: oklch(0.7 0.15 150 / 0.4);
  background: oklch(0.7 0.15 150 / 0.08);
}
.docs-hint-success .docs-hint-icon {
  color: oklch(0.5 0.15 150);
}
.docs-hint-warning {
  border-color: oklch(0.75 0.15 80 / 0.5);
  background: oklch(0.75 0.15 80 / 0.1);
}
.docs-hint-warning .docs-hint-icon {
  color: oklch(0.6 0.14 70);
}
.docs-hint-danger {
  border-color: oklch(0.6 0.2 25 / 0.4);
  background: oklch(0.6 0.2 25 / 0.08);
}
.docs-hint-danger .docs-hint-icon {
  color: oklch(0.55 0.2 25);
}

.docs-tabs {
  border: 1px solid var(--border);
  border-radius: 12px;
  overflow: hidden;
}
.docs-tabs-header {
  display: flex;
  gap: 2px;
  padding: 6px 8px 0;
  background: var(--muted);
  border-bottom: 1px solid var(--border);
}
.docs-tabs-header button {
  padding: 7px 14px;
  font-size: 13.5px;
  border-radius: 8px 8px 0 0;
  color: var(--muted-foreground);
}
.docs-tabs-header .docs-tab-active {
  background: var(--background);
  color: var(--foreground);
  font-weight: 500;
}
.docs-tabs-body {
  padding: 14px 16px;
}

.docs-expandable {
  border: 1px solid var(--border);
  border-radius: 12px;
}
.docs-expandable summary {
  padding: 12px 16px;
  font-weight: 500;
  cursor: pointer;
}
.docs-expandable-body {
  padding: 0 16px 14px;
}

.docs-stepper .docs-step {
  display: flex;
  gap: 14px;
}
.docs-step-rail {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.docs-step-badge {
  width: 28px;
  height: 28px;
  border-radius: 999px;
  background: var(--muted);
  border: 1px solid var(--border);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 600;
}
.docs-step-line {
  width: 1px;
  flex: 1;
  background: var(--border);
  margin: 4px 0;
}
.docs-step-main {
  flex: 1;
  min-width: 0;
  padding-bottom: 20px;
}
.docs-step-title {
  font-weight: 600;
  margin: 4px 0 6px;
}

.docs-embed {
  width: 100%;
  aspect-ratio: 16 / 9;
  border: 1px solid var(--border);
  border-radius: 12px;
}
.docs-content-ref {
  display: flex !important;
  align-items: center;
  gap: 10px;
  padding: 13px 16px;
  border: 1px solid var(--border);
  border-radius: 12px;
  font-weight: 500;
  text-decoration: none !important;
  color: var(--foreground) !important;
}
.docs-content-ref:hover {
  background: var(--accent);
}

.docs-columns {
  display: flex;
  gap: 20px;
}
.docs-column {
  flex: 1;
  min-width: 0;
}

.docs-code {
  border: 1px solid var(--border);
  border-radius: 12px;
  overflow: hidden;
}
.docs-code-header {
  display: flex;
  justify-content: space-between;
  padding: 7px 14px;
  background: var(--muted);
  border-bottom: 1px solid var(--border);
  font-size: 12.5px;
  font-weight: 500;
}
.docs-code-lang {
  color: var(--muted-foreground);
  font-weight: 400;
}
.docs-code pre {
  padding: 13px 15px;
  overflow-x: auto;
  font-family: ui-monospace, Menlo, monospace;
  font-size: 13px;
  line-height: 1.55;
  background: oklch(0.18 0.01 260);
  color: oklch(0.92 0.01 260);
}
.docs-code-line {
  display: flex;
  gap: 14px;
}
.docs-code-lineno {
  color: oklch(0.55 0.01 260);
  width: 1.5em;
  text-align: right;
  flex-shrink: 0;
  user-select: none;
}

.docs-table {
  border-collapse: collapse;
  width: 100%;
}
.docs-table th,
.docs-table td {
  border: 1px solid var(--border);
  padding: 8px 12px;
  text-align: left;
}
.docs-table th {
  background: var(--muted);
  font-weight: 600;
}

.docs-math {
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 14px 16px;
  background: var(--muted);
  font-family: ui-monospace, Menlo, monospace;
  font-size: 13.5px;
  text-align: center;
  white-space: pre-wrap;
}
.docs-code pre code {
  background: none;
  padding: 0;
  font-size: inherit;
}

/* --- Updates (changelog) --- */
.gb-updates {
  margin: 0.7em 0;
}
.gb-update {
  display: flex;
  gap: 16px;
  padding: 14px 0;
  border-top: 1px solid var(--border);
}
.gb-update-date {
  width: 130px;
  flex-shrink: 0;
  font-size: 13px;
  color: var(--muted-foreground);
  padding-top: 4px;
}
.gb-update-body {
  flex: 1;
  min-width: 0;
}
.docs-updates {
  border-top: 1px solid var(--border);
}
.docs-update {
  display: flex;
  gap: 20px;
  padding: 18px 0;
  border-bottom: 1px solid var(--border);
}
.docs-update-date {
  width: 130px;
  flex-shrink: 0;
  font-size: 13px;
  color: var(--muted-foreground);
  padding-top: 6px;
}
.docs-update-body {
  flex: 1;
  min-width: 0;
}

/* --- Cards table view --- */
.docs-cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 14px;
}
.docs-card {
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 16px;
  min-height: 70px;
}
.docs-card:hover {
  background: var(--accent);
}
.docs-card-title {
  font-weight: 600;
}
.docs-card-body {
  font-size: 13.5px;
  color: var(--muted-foreground);
  margin-top: 4px;
}

/* --- Mermaid --- */
.docs-mermaid {
  display: flex;
  justify-content: center;
  padding: 16px;
  border: 1px solid var(--border);
  border-radius: 12px;
  background: var(--background);
}
.docs-mermaid svg {
  max-width: 100%;
}
.docs-mermaid-error {
  font-size: 12px;
  color: oklch(0.55 0.2 25);
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 10px;
  white-space: pre-wrap;
}

/* --- OpenAPI operation --- */
.gb-openapi {
  margin: 0.7em 0;
}
.gb-openapi-fields {
  display: flex;
  gap: 10px;
  padding: 8px 12px;
  border: 1px dashed var(--border);
  border-radius: 8px 8px 0 0;
  font-size: 12px;
}
.gb-openapi-fields .gb-inline-input {
  color: var(--muted-foreground);
}
.gb-openapi-path {
  min-width: 110px;
}
.gb-openapi-url {
  flex: 1;
}
.oas {
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 18px 20px;
  margin: 0.7em 0;
}
.oas-empty {
  color: var(--muted-foreground);
  font-size: 14px;
}
.oas-title {
  font-size: 1.35em;
  font-weight: 700;
  margin-bottom: 10px;
}
.oas-endpoint {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 12px;
}
.oas-method {
  font-size: 12px;
  font-weight: 700;
  padding: 3px 9px;
  border-radius: 7px;
  letter-spacing: 0.03em;
}
.oas-method-get {
  background: oklch(0.7 0.15 150 / 0.15);
  color: oklch(0.45 0.13 150);
}
.oas-method-post {
  background: oklch(0.7 0.12 240 / 0.15);
  color: oklch(0.45 0.13 240);
}
.oas-method-put,
.oas-method-patch {
  background: oklch(0.75 0.15 80 / 0.18);
  color: oklch(0.5 0.12 70);
}
.oas-method-delete {
  background: oklch(0.6 0.2 25 / 0.13);
  color: oklch(0.5 0.19 25);
}
.oas-server {
  font-size: 13px;
  color: var(--muted-foreground);
  background: var(--muted);
  border-radius: 7px;
  padding: 3px 9px;
  font-family: ui-monospace, Menlo, monospace;
}
.oas-path {
  font-family: ui-monospace, Menlo, monospace;
  font-size: 14px;
  background: none !important;
}
.oas-desc {
  color: var(--foreground);
  margin-bottom: 8px;
}
.oas-section {
  margin-top: 18px;
}
.oas-section h4 {
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 8px;
  padding-bottom: 6px;
  border-bottom: 1px solid var(--border);
}
.oas-field {
  padding: 7px 0;
  font-size: 13.5px;
}
.oas-field-name {
  font-weight: 600;
  background: none !important;
  padding: 0 !important;
}
.oas-field-type {
  color: var(--muted-foreground);
}
.oas-required {
  color: oklch(0.6 0.13 70);
  font-size: 12px;
}
.oas-optional {
  color: var(--muted-foreground);
  font-size: 12px;
}
.oas-field-desc {
  color: var(--muted-foreground);
  font-size: 13px;
  margin-top: 2px;
}
.oas-fields {
  padding-left: 10px;
  border-left: 2px solid var(--border);
  margin-top: 6px;
}
.oas-response summary {
  display: flex;
  gap: 10px;
  align-items: center;
  cursor: pointer;
  padding: 7px 0;
  font-size: 13.5px;
}
.oas-code {
  font-size: 12px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 6px;
  font-family: ui-monospace, Menlo, monospace;
}
.oas-code-2 {
  background: oklch(0.7 0.15 150 / 0.15);
  color: oklch(0.45 0.13 150);
}
.oas-code-4,
.oas-code-5 {
  background: oklch(0.6 0.2 25 / 0.13);
  color: oklch(0.5 0.19 25);
}
.oas-code-3 {
  background: oklch(0.75 0.15 80 / 0.18);
  color: oklch(0.5 0.12 70);
}
.oas-samples {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
}
.oas-sample {
  border: 1px solid var(--border);
  border-radius: 10px;
  overflow: hidden;
}
.oas-sample-head {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 7px 12px;
  background: var(--muted);
  font-size: 12.5px;
}
.oas-sample-head code {
  background: none;
  font-family: ui-monospace, Menlo, monospace;
}
.oas-sample-label {
  margin-left: auto;
  color: var(--muted-foreground);
}
.oas-sample pre {
  padding: 12px 14px;
  font-family: ui-monospace, Menlo, monospace;
  font-size: 12.5px;
  line-height: 1.55;
  overflow-x: auto;
  background: oklch(0.18 0.01 260);
  color: oklch(0.92 0.01 260);
}

/* --- Repo sidebar / file tree --- */
.gb-sidebar-scroll {
  flex: 1;
  overflow-y: auto;
  padding: 8px;
}
.gb-section-label {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--muted-foreground);
  padding: 8px 10px 4px;
}
.gb-sidebar-note {
  font-size: 13px;
  color: var(--muted-foreground);
  padding: 6px 10px;
}
.gb-sidebar-note a {
  text-decoration: underline;
}
.repo-item {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  padding: 6px 10px;
  border-radius: 6px;
  font-size: 13.5px;
  color: var(--foreground);
  text-align: left;
}
.repo-item:hover {
  background: var(--accent);
}
.repo-item-active {
  background: var(--accent);
  font-weight: 500;
}
.repo-owner {
  margin-left: auto;
  font-size: 11px;
  color: var(--muted-foreground);
}
.repo-tree {
  margin: 2px 0 6px;
  border-left: 1px solid var(--border);
  margin-left: 16px;
}
.tree-dir,
.tree-file {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  padding: 4px 8px;
  font-size: 13px;
  color: var(--muted-foreground);
  border-radius: 6px;
  text-align: left;
}
.tree-dir:hover,
.tree-file:hover {
  background: var(--accent);
  color: var(--accent-foreground);
}
.tree-file-active {
  background: var(--accent);
  color: var(--accent-foreground);
  font-weight: 500;
}

/* --- Header / sync --- */
.gb-file-path {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13.5px;
  font-weight: 500;
  font-family: ui-monospace, Menlo, monospace;
  min-width: 0;
}
.gb-sync {
  display: flex;
  align-items: center;
  gap: 8px;
}
.gb-sync-state {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12.5px;
  color: oklch(0.5 0.13 150);
}
.gb-sync-dirty {
  color: oklch(0.6 0.13 70);
}

/* --- Slash menu --- */
.slash-menu {
  z-index: 100;
  min-width: 230px;
  max-height: 320px;
  overflow-y: auto;
  background: var(--popover);
  border: 1px solid var(--border);
  border-radius: 10px;
  box-shadow: 0 10px 30px rgb(0 0 0 / 0.14);
  padding: 5px;
}
.slash-item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 7px 10px;
  border-radius: 7px;
  font-size: 13.5px;
  color: var(--foreground);
  text-align: left;
}
.slash-item-active {
  background: var(--accent);
}
.slash-item svg {
  color: var(--muted-foreground);
}
.slash-empty {
  padding: 8px 10px;
  font-size: 13px;
  color: var(--muted-foreground);
}
.gb-toolbar-hint {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-left: auto;
  font-size: 12px;
  color: var(--muted-foreground);
  padding-right: 6px;
}
.gb-toolbar-hint kbd {
  border: 1px solid var(--border);
  border-radius: 4px;
  padding: 0 5px;
  font-size: 11px;
  background: var(--muted);
}
.gb-inline-img-wrap {
  display: inline-block;
  vertical-align: middle;
}
.gb-inline-img,
.docs-inline-img {
  display: inline-block;
  vertical-align: middle;
  border-radius: 4px;
}
.docs-inline-img-link {
  text-decoration: none !important;
}
.docs-code pre {
  background: var(--muted);
  color: var(--foreground);
}
.docs-code pre code.hljs {
  background: none;
  padding: 0;
}
.gb-code pre code .hljs-comment {
  font-style: italic;
}
.gb-commit-panel {
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 10px 20px;
  border-bottom: 1px solid var(--border);
  background: var(--muted);
}
.gb-commit-message {
  max-width: 420px;
  background: var(--background);
}

/* --- Owner switcher + sidebar search --- */
.gb-sidebar-head {
  position: relative;
}
.gb-owner-switch {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  border-radius: 8px;
  padding: 4px 6px;
  text-align: left;
}
.gb-owner-switch:hover {
  background: var(--accent);
}
.gb-owner-avatar {
  width: 24px;
  height: 24px;
  border-radius: 6px;
  flex-shrink: 0;
}
.gb-owner-menu {
  position: absolute;
  top: calc(100% - 6px);
  left: 10px;
  right: 10px;
  z-index: 40;
  background: var(--popover);
  border: 1px solid var(--border);
  border-radius: 10px;
  box-shadow: 0 10px 30px rgb(0 0 0 / 0.14);
  padding: 5px;
  max-height: 320px;
  overflow-y: auto;
}
.gb-owner-item {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 6px 8px;
  border-radius: 7px;
  font-size: 13.5px;
  text-align: left;
}
.gb-owner-item:hover {
  background: var(--accent);
}
.gb-owner-item-active {
  background: var(--accent);
  font-weight: 500;
}
.gb-owner-tag {
  margin-left: auto;
  font-size: 10.5px;
  color: var(--muted-foreground);
  border: 1px solid var(--border);
  border-radius: 999px;
  padding: 1px 7px;
}
.gb-sidebar-search {
  display: flex;
  align-items: center;
  gap: 7px;
  margin: 8px 10px 0;
  padding: 6px 9px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--background);
  color: var(--muted-foreground);
}
.gb-sidebar-search input {
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  font-size: 13px;
  color: var(--foreground);
}
.gb-sidebar-search button {
  display: flex;
  color: var(--muted-foreground);
}

/* ===================== github-clone markdown ===================== */

.markdown-body {
  font-size: 14px;
  line-height: 1.6;
  word-wrap: break-word;
}
.markdown-body > * + * {
  margin-top: 0.85em;
}
.markdown-body h1,
.markdown-body h2 {
  font-weight: 600;
  padding-bottom: 0.3em;
  border-bottom: 1px solid var(--border);
}
.markdown-body h1 {
  font-size: 1.7em;
}
.markdown-body h2 {
  font-size: 1.4em;
  margin-top: 1.2em;
}
.markdown-body h3 {
  font-size: 1.15em;
  font-weight: 600;
  margin-top: 1em;
}
.markdown-body h4,
.markdown-body h5,
.markdown-body h6 {
  font-weight: 600;
}
.markdown-body ul {
  list-style: disc;
  padding-left: 2em;
}
.markdown-body ol {
  list-style: decimal;
  padding-left: 2em;
}
.markdown-body li + li {
  margin-top: 0.25em;
}
.markdown-body a {
  color: oklch(0.62 0.17 255);
  text-decoration: underline;
}
.markdown-body code {
  background: var(--muted);
  border-radius: 4px;
  padding: 0.15em 0.35em;
  font-family: ui-monospace, Menlo, monospace;
  font-size: 0.875em;
}
.markdown-body pre {
  background: var(--muted);
  border-radius: 8px;
  padding: 16px;
  overflow-x: auto;
  font-family: ui-monospace, Menlo, monospace;
  font-size: 12px;
  line-height: 1.5;
}
.markdown-body pre code {
  background: none;
  padding: 0;
  font-size: inherit;
}
.markdown-body blockquote {
  border-left: 3px solid var(--border);
  padding-left: 1em;
  color: var(--muted-foreground);
}
.markdown-body hr {
  border: none;
  border-top: 1px solid var(--border);
  margin: 1.5em 0;
}
.markdown-body table {
  border-collapse: collapse;
  display: block;
  overflow-x: auto;
}
.markdown-body th,
.markdown-body td {
  border: 1px solid var(--border);
  padding: 6px 12px;
}
.markdown-body th {
  background: var(--muted);
  font-weight: 600;
}
.markdown-body img {
  max-width: 100%;
}
